import { FC, useCallback, useEffect, useRef, useState } from 'react';
import './app-detail.less';
import {
  Modal,
  SvgIcon,
  Loading,
  NavAnchorContent,
  Button,
} from '@/components';
import Tooltip from 'rc-tooltip';
import Message from 'rc-message';
import copy from 'copy-to-clipboard';
import dayjs from 'dayjs';
import { useImmer } from 'use-immer';
import MultiLanEditModal, {
  EditModalSourceType,
  SourceType,
} from './MultiLanEditModal';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { apiService, AppInfo, ImplListRespItem, WidgetInfo } from '@/shared';
import VersionSelect from './VersionSelect';
import OffLineModal from './OffLineModal';
import SortSelect from './SortSelect';
// import { appStatusMap, styleMap } from './const';
import { urlQuery, formatDate } from '@/shared/utils/tools';
import { useHistory } from 'react-router-dom';
import classnames from 'classnames';
import StatusTag from './StatusTag';
import SearchSelectBar from './SearchSelectBar';
import NotifyModal from './NotifyModal';
import UpdateImplButton from './UpdateImplButton';
import { unionBy } from 'lodash-es';
import { useLocation } from 'react-router';
import { statusMap, STORE_OFFLINE_CODE, widgetListTemp } from './const';
// import ListContent from './components/ListContent';
/**
 * 
 *  DEFAULT(0, "草稿"),
    ONLINE(1, "上架"),
    OFFLINE(2, "应用商店下线"),
    DELETED(3, "删除"),
    UNDER_TEST(4,"测试中"),
    CANCEL_TEST(5,"取消测试"),
    COMPLETE_TEST(6,"完成测试"),
    UNDER_APPROVAL(7,"审核中"),
    REJECT_APPROVAL(8,"驳回审核"),
    CANCEL_APPROVAL(9,"撤销审核"),
    FILLED(10, "已填写"),
    OPERATE_OFFLINE(11, "运营下架"),
 * 
 */
export const STATUS: keyof WidgetInfo = 'status';
/** 更新资料的状态 */
export const UPDATE_STATUS: keyof WidgetInfo = 'updateStatus';
interface RefProps {
  /** 防止多次提交 */
  commitingFlag: boolean;
}
/**
 * 版本列表接口需要设个cookie
  userId=3150047122
 */
// 先通过url中的包名调接口得到appInfo
// 通过appInfo调接口得到组件版本getAppVersionList
// getAppVersionList[0] 调用接口获取最高版本的组件列表
// --原来appInfo中返回的最高版本有可能没有组件，但是getAppVersionList一定是有组件的--
export const AppDetail: FC = (props) => {
  const history = useHistory();
  const location = useLocation();
  const { appPkgName, appVerCode, updateType } = urlQuery(); // 从url取的参数
  const [appInfo, setAppInfo] = useState<AppInfo>({} as AppInfo); // 我的应用信息
  const [sourceListData, setSourceListData] = useImmer<ImplListRespItem[]>([]); // 接口返回的list
  const [listData, setListData] = useImmer<WidgetInfo[]>([]); // 改造后的list
  const [editModalInfo, setEditModalInfo] = useState<WidgetInfo>(
    {} as WidgetInfo,
  ); // 编辑弹窗回显信息
  const [editModalVisible, setEditModalVisible] = useState<boolean>(false); // 是否显示编辑弹窗
  const [editModalSource, setEditModalSource] = useState<SourceType>(
    EditModalSourceType.Edit,
  ); //  打开编辑弹窗的方式，是查看还是编辑还是更新
  const [offlineModalVisible, setOfflineModalVisible] = useState<boolean>(
    false,
  ); // 是否显示下线弹窗
  const [commited, setCommited] = useState<boolean>(true); // 是否提交过
  const [agree, setAgree] = useState<boolean>(false); // 底部同意按钮
  const cRefs = useRef<RefProps>({ commitingFlag: false }); // 防止多次提交
  const [loading, setLoading] = useState<boolean>(false); //
  const [abilityVersion, setAbilityVersion] = useState<number>(null!); // 当前显示的组件的app的abilityVersion
  const [selectedAbilityVersions, setSelectedAbilityVersions] = useState<
    number[]
  >([]); // 管理状态下且搜索出来的单个组件选中的版本
  const [notifyModalVisible, setNotifyModalVisible] = useState<boolean>(false); // 商店下架，弹窗提醒
  //小部件列表信息
  const [widgetList, setWidgetList] = useImmer<WidgetInfo[]>([]);

  const appStatusMap = new Map<number, string>([
    [0, window.trans('status-down')],
    [1, window.trans('status-shelf')],
  ]);
  //根据包名获取信息
  const getWidgetList = useCallback(async () => {
    setLoading(false);
    const data = await apiService.getWidget(
      appPkgName as string,
      appVerCode as string,
    );
    setWidgetList(data.widgetList || []);
  }, [appPkgName, appVerCode]);
  useEffect(() => {
    getWidgetList();
  }, [getWidgetList]);

  useEffect(() => {
    const appInfo = JSON.parse(sessionStorage.getItem('appInfo') || '');
    appInfo && setAppInfo(appInfo as AppInfo);
  }, []);

  // 交换顺序接口
  const changeDragApi = useCallback(
    async (startIndex: number, endIndex: number) => {
      const implSortBOList: number[] = [],
        up = startIndex > endIndex;
      let i = startIndex;
      // while (up ? i >= endIndex : i <= endIndex) {
      //     // eslint-disable-next-line no-loop-func
      //   widgetList.map((d: WidgetInfo) => {
      //     implSortBOList.push(d.id)
      //   }),
      //   up ? i-- : i++;
      // }
      widgetList.map((d: WidgetInfo) => {
        implSortBOList.push(d.id);
      });
      try {
        const res = await apiService.imlpSort({
          appPkgName: appPkgName as string,
          implSortBOList,
        });
        if (res === true) {
          console.log('交换成功');
        }
      } catch (error) {
      } finally {
        getWidgetList();
      }
    },
    [widgetList],
  );
  // 改变两个顺序
  const changeSortFn = useCallback(
    async (startIndex: number, endIndex: number) => {
      try {
        if (startIndex === endIndex) return;
        setWidgetList((draft: WidgetInfo[]) => {
          const [removed] = draft.splice(startIndex, 1);
          draft.splice(endIndex, 0, removed);
        });
        const widgetTemp = [...widgetList];
        const [removed] = widgetTemp.splice(startIndex, 1);
        widgetTemp.splice(endIndex, 0, removed);
        const implSortBOList: number[] = [];
        const temp = widgetTemp.map((d: WidgetInfo) => {
          implSortBOList.push(d.id);
        });
        try {
          const res = await apiService.imlpSort({
            appPkgName: appPkgName as string,
            implSortBOList,
          });
          if (res === true) {
            console.log('交换成功');
          }
        } catch (error) {
        } finally {
          getWidgetList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    [changeDragApi],
  );

  //list列表
  const ListContent = (props: { name: string; list: WidgetInfo }) => {
    const { name, list } = props;
    const isRedArr = ['unpass', 'tokeoff', 'offline'];
    const statusClassName: string = statusMap.get(list[STATUS]) || '';
    let statusName: string = '';
    let operationName: string = '';
    let clickFn: () => void = () => {};
    const isRed: boolean = isRedArr.includes(statusClassName);
    switch (statusClassName) {
      case 'unready':
        statusName = window.trans('tobe-filled');
        operationName = window.trans('edit');
        clickFn = () => {
          setEditModalInfo(list);
          setEditModalVisible(true);
          setEditModalSource(EditModalSourceType.Edit);
        };
        break;
      case 'ready':
        statusName = window.trans('filled');
        operationName = window.trans('reedit');
        clickFn = () => {
          setEditModalInfo(list);
          setEditModalVisible(true);
          setEditModalSource(EditModalSourceType.Edit);
        };
        break;
      case 'under-review':
        statusName = window.trans('under-review');
        operationName = window.trans('detile');
        clickFn = () => {
          setEditModalInfo(list);
          setEditModalVisible(true);
          setEditModalSource(EditModalSourceType.View);
        };
        break;
      case 'published':
        statusName = window.trans('published');
        operationName = window.trans('apply-down');
        clickFn = () => {
          setEditModalInfo(list);
          setOfflineModalVisible(true);
        };
        break;
      case 'unpass':
        statusName = window.trans('rejected');
        operationName = window.trans('reedit');
        clickFn = () => {
          setEditModalInfo(list);
          setEditModalVisible(true);
          setEditModalSource(EditModalSourceType.Edit);
        };
        break;
      case 'tokeoff':
        statusName = window.trans('take-down');
        operationName = window.trans('reedit');
        clickFn = () => {
          setEditModalInfo(list);
          setEditModalVisible(true);
          setEditModalSource(EditModalSourceType.Edit);
        };
        break;
      // case 'offline':
      //   statusName = '被下架';
      //   operationName = '查看详情';
      //   clickFn = () => {
      //     setEditModalInfo(list);
      //     setEditModalVisible(true);
      //     setEditModalSource(EditModalSourceType.View);
      //   };
      //   break;
    }
    return (
      <>
        <ul key={name} className={classnames('layout-ul clearfix pr')}>
          <li className="icon">
            <SvgIcon
              className="cursor"
              style={{
                fill: '#2A3E64',
                opacity: 1,
              }}
              name={'drag'}
              width="30"
              height="30"
            />
          </li>
          <li className="name elipsis">
            <span
              className="cursor"
              title={list.name}
              onClick={() => {
                setEditModalInfo(list);
                setEditModalVisible(true);
                setEditModalSource(EditModalSourceType.View);
              }}
            >
              {list.name}
            </span>
          </li>
          <li className="id elipsis flex-start">
            <span
              className="db elipsis"
              style={{ marginRight: '5px' }}
              title={`${list.widgetId}`}
            >
              {list.widgetId}
            </span>
            <SvgIcon
              onClick={() => {
                copy(`${list.widgetId}`);
                Message.success({
                  content: window.trans('copy-sucess'),
                });
              }}
              className="cursor"
              name="copy"
              width="16"
              height="16"
            />
          </li>
          <li className="size">{list.size}</li>
          <li className="status flex-center">
            <StatusTag
              info={list}
              isRed={isRed}
              statusClassName={statusClassName}
              statusName={statusName}
            />
          </li>
          <li className="operation">
            {/* 更新资料需求 */}
            {statusClassName === 'published' && (
              <UpdateImplButton
                item={list}
                onClick={(formDisable: boolean) => {
                  setEditModalInfo(list);
                  setEditModalVisible(true);
                  setEditModalSource({
                    type: EditModalSourceType.Update,
                    formDisable,
                  });
                }}
              />
            )}
            <div
              className="opt-btn cursor"
              onClick={() => {
                clickFn();
              }}
            >
              <span>{operationName}</span>
              <SvgIcon
                style={{
                  marginLeft: '7px',
                  fill: isRed ? '#de0000' : '#2A3E64',
                }}
                className="arrow-right"
                name={'arrow-down'}
                width="12"
                height="6"
              />
            </div>
          </li>
          {list.new === true && (
            <div className="isAdd pa" style={{ top: '15px', right: '-95px' }}>
              <span>{window.trans('add')}</span>
            </div>
          )}
        </ul>
      </>
    );
  };
  // commit 提交
  const commitFn = useCallback(async () => {
    if (cRefs.current.commitingFlag) return;
    cRefs.current.commitingFlag = true;
    try {
      const res = await apiService.commit({
        appPkgName: appPkgName as string,
        verCode: appVerCode as string,
      });
      if (res) {
        Modal.success({
          title: window.trans('onlineing'),
          afterClose() {
            getWidgetList();
          },
          content: (
            <div style={{ marginBottom: '70px' }}>
              <p>{window.trans('passed-tips')}</p>
              <p>{window.trans('dead-line')}</p>
            </div>
          ),
          sureContent: <span>{window.trans('submit-sucess')}</span>,
        });
      }
    } catch (error) {
    } finally {
      cRefs.current.commitingFlag = false;
    }
  }, [appInfo, abilityVersion, sourceListData]);

  // 可以提交-不包含待填写、且含有（已填写 | 已发布且资料待提交审核态）
  const commitBtnIsAc =
    agree &&
    widgetList.every((d) => {
      return statusMap.get(d[STATUS]) !== 'unready';
    }) &&
    widgetList.some((d) => {
      const status = statusMap.get(d[STATUS]);
      const updateStatus = statusMap.get(d[UPDATE_STATUS]);
      return (
        status === 'ready' ||
        (status === 'published' && updateStatus === 'ready')
      );
    });
  // 要渲染的数据
  let renderData: WidgetInfo[] = [];
  renderData = widgetList;

  // 搜索的时候默认没有选中版本，展示全部数据
  // if (!selectedAbilityVersions.length) {
  //   renderData = widgetList;
  // }
  // else {
  //   renderData = widgetList.filter((d: WidgetInfo) => {
  //     return selectedAbilityVersions.includes(d.appVers.verName as number);
  //   });
  // }
  return (
    <div className="app-detail-wrapper">
      {/* 我的应用 */}
      <NavAnchorContent
        id="my-app"
        label={window.trans('my-app')}
        isLink={false}
      >
        <section className="my-app main-content">
          <div className="title-div">
            <span className="t">{window.trans('my-app')}</span>
          </div>
          <div className="card">
            <div className="l fl tc">
              <div className="img-box">
                <img src={appInfo.icon} alt="" />
              </div>
              <p className="tc">{appInfo.appName}</p>
            </div>
            <div className="m fl">
              <ul className="m-ul">
                <li className="m-li">
                  <div className="li-top">
                    <span>{window.trans('pkg-name')}</span>
                    <a
                      target="_blank"
                      href="https://dev.mi.com/console/doc/detail?pId=1002"
                      rel="noreferrer"
                    >
                      <SvgIcon
                        className="cursor"
                        name="dis"
                        width="16"
                        height="16"
                      />
                    </a>
                  </div>
                  <div className="input-box flex flex-between">
                    <span>{appInfo.pkgName}</span>
                    <SvgIcon
                      onClick={() => {
                        copy(appInfo.pkgName);
                        Message.success({
                          content: window.trans('copy-sucess'),
                        });
                      }}
                      className="cursor"
                      name="copy"
                      width="19"
                      height="19"
                    />
                  </div>
                </li>
                <li className="m-li">
                  <div className="li-top">
                    <span>
                      {Number(updateType) === 2 ? 'Deeplink URL' : 'App ID'}
                    </span>
                  </div>
                  <div className="input-box flex flex-between">
                    <span>
                      {Number(updateType) === 2
                        ? appInfo.downloadUrl
                        : appInfo.appId}
                    </span>
                    <SvgIcon
                      onClick={() => {
                        if (Number(updateType) === 2) {
                          copy(appInfo.downloadUrl);
                        } else {
                          copy(String(appInfo.appId));
                        }
                        Message.success({
                          content: window.trans('copy-sucess'),
                        });
                      }}
                      className="cursor"
                      name="copy"
                      width="19"
                      height="19"
                    />
                  </div>
                </li>
                <li className="m-li">
                  <div className="li-top">
                    <span>{window.trans('update-time')}</span>
                    <Tooltip
                      placement="top"
                      overlay={<span>{window.trans('last-upload-time')}</span>}
                    >
                      <SvgIcon
                        className="cursor"
                        name="dis"
                        width="16"
                        height="16"
                      />
                    </Tooltip>
                  </div>
                  <div className="input-box flex flex-between">
                    <span>
                      {appInfo.updateTime && dayjs(appInfo.updateTime).format('YYYY-MM-DD : HH:ss')}
                    </span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="r fl">
              <ul className="r-ul">
                <li className="r-li">
                  <dl>
                    <dt>{window.trans('language')}</dt>
                    <dd>简体中文</dd>
                  </dl>
                </li>
                <li className="r-li">
                  <dl>
                    <dt>{window.trans('latest-version')}</dt>
                    {appInfo.currVer && <dd>{appInfo.currVer.verName}</dd>}
                  </dl>
                </li>
                <li className="r-li">
                  <dl>
                    <dt>{window.trans('status')}</dt>
                    <dd>{appStatusMap.get(appInfo.status)}</dd>
                  </dl>
                </li>
              </ul>
              <ul className="r-ul">
                <li className="r-li">
                  <dl>
                    <dt>{window.trans('first-category')}</dt>
                    <dd>{appInfo.category}</dd>
                  </dl>
                </li>
                <li className="r-li">
                  <dl>
                    <dt>{window.trans('second-category')}</dt>
                    <dd>{appInfo.parentCategory}</dd>
                  </dl>
                </li>
              </ul>
            </div>
          </div>
        </section>
      </NavAnchorContent>

      {/* 小部件详情 */}
      <NavAnchorContent
        id="widget-detail"
        label={window.trans('widget-detile')}
        isLink={false}
      >
        <section className="widget-detail main-content">
          <div className="title-div flex-between">
            <span className="t">{window.trans('widget-detile')}</span>
          </div>
          <div className="tip-div flex flex-between">
            <div className="left flex">
              <SvgIcon
                className="cursor"
                style={{ fill: '#0476EB' }}
                name="error"
                width="30"
                height="30"
              />
              {/* <span className="tip-title">{window.trans('review-tips')}:</span> */}
              <span className="tip-content">
              {window.trans('review-tips')}: {window.trans('sort-tips')}
              </span>
            </div>
            {/* <div className="right tr flex flex-end">
              <span className="j">详情见</span>
               <Button 
                className="xz"
                type='primary'
                href="https://dev.mi.com/console/doc/detail?pId=2458"
              >小部件上传须知</Button> 
            </div> */}
          </div>
          {/* 列表 */}
          <Loading loading={loading}>
            <div className="widget-list-box">
              <ul className="widget-list-ul-top layout-ul clearfix pr">
                <li className="order pa">
                  <span className="z">{window.trans('sort')}</span>
                </li>
                <li className="icon"></li>
                <li className="name">
                  <span className="z">{window.trans('widget-name')}</span>
                </li>
                <li className="id">
                  <span className="z">ID</span>
                </li>
                <li className="size">
                  <span className="z">{window.trans('size')}</span>
                </li>
                <li className="status tc">
                  <span className="z">{window.trans('status')}</span>
                </li>
                <li className="operation">
                  <span className="z">{window.trans('action')}</span>
                </li>
              </ul>
              {/* 可拖拽的列表 */}
              {/* https://github.com/atlassian/react-beautiful-dnd */}
              <DragDropContext
                onDragStart={(result) => {
                  const { source } = result;
                  if (!source) return;
                  setWidgetList((draft: WidgetInfo[]) => {
                    draft[source.index].dragging = true;
                  });
                }}
                onDragEnd={(result: {
                  source?: {
                    index: number;
                  };
                  destination?: {
                    index: number;
                  };
                }) => {
                  setWidgetList((draft: WidgetInfo[]) => {
                    draft.forEach((d: WidgetInfo) => {
                      if (d.dragging) {
                        d.dragging = false;
                      }
                    });
                  });
                  // 拖出屏幕后下面两个值有的为null
                  const { source, destination } = result;
                  if (!source || !destination) return;
                  changeSortFn(source.index, destination.index);
                }}
              >
                <Droppable droppableId="droppable">
                  {(provided, snapshot) => {
                    return (
                      <ul
                        className={`widget-list-ul ${
                          commited ? 'commited' : 'un-commited'
                        }`}
                        ref={provided.innerRef}
                        // style={{ backgroundColor: snapshot.isDraggingOver ? 'blue' : 'grey' }}
                        {...provided.droppableProps}
                      >
                        {renderData.map((item: WidgetInfo, index: number) => {
                          return (
                            <Draggable
                              key={item.id}
                              draggableId={`${item.id}`}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <li
                                  className={`widget-list-li ${
                                    item.dragging ? 'dragging' : ''
                                  }`}
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <div className="sort-box-wrapper pa tr">
                                    <li className='sort-num'>{index + 1}</li>
                                  </div>
                                  {/* list每一项前面的页码和排序 */}
                                  <ListContent name={item.name} list={item} />
                                </li>
                              )}
                            </Draggable>
                          );
                        })}
                        {provided.placeholder}
                      </ul>
                    );
                  }}
                </Droppable>
              </DragDropContext>
            </div>
          </Loading>
        </section>
      </NavAnchorContent>
      {/* 底下同意协议和提交 */}
      <NavAnchorContent
        id="agree-and-submit"
        label={window.trans('submit-review')}
        isLink={false}
      >
        {widgetList.length > 0 && (
          <section className="agree-and-submit">
            <div className="tc agree">
              <label htmlFor="agree-input">
                <div className={`agree-div ${agree && 'ac'}`}>
                  <SvgIcon
                    name={'success'}
                    width="22"
                    height="22"
                    style={{ fill: '#00b860' }}
                  />
                </div>
                <input
                  id="agree-input"
                  checked={agree}
                  onChange={(e) => setAgree(e.target.checked)}
                  type="checkbox"
                />
              </label>
              <span>
                { window.trans('agree-widget-show') }
                <a
                  className="mag-link"
                  rel="noreferrer"
                  target="_blank"
                  href="https://dev.mi.com/console/doc/detail?pId=2476"
                >
                  { window.trans('widget-show-tips') }
                </a>
              </span>
            </div>
            <div className="opt tc">
              <Button
                className="back"
                onClick={() => {
                  history.goBack();
                }}
              >
                {window.trans('return')}
              </Button>
              <Button
                type="primary"
                disable={!commitBtnIsAc}
                className="submit"
                onClick={() => {
                  commitFn();
                }}
              >
                {window.trans('submit-audit')}
              </Button>
            </div>
          </section>
        )}
      </NavAnchorContent>
      {/* 二期多语言弹窗  */}
      <MultiLanEditModal
        source={editModalSource}
        info={editModalInfo}
        appInfo={appInfo}
        close={(bool: boolean) => {
          setEditModalVisible(false);
          if (bool) {
            getWidgetList();
          }
        }}
        visible={editModalVisible}
      />
      {/* 下线弹窗 */}
      <OffLineModal
        info={editModalInfo}
        appId={appInfo.appId}
        visible={offlineModalVisible}
        close={(bool: boolean) => {
          setOfflineModalVisible(false);
          if (bool) {
            getWidgetList();
          }
        }}
      />
      {/* 商店下线提示弹窗 */}
      <NotifyModal
        visible={notifyModalVisible}
        onClose={() => setNotifyModalVisible(false)}
      />
    </div>
  );
};
